import React from "react";
import { makeStyles } from "@material-ui/styles";
import { navigate } from "gatsby";
import ButtonBase from "@material-ui/core/ButtonBase";
import Typography from "@material-ui/core/Typography";
import GuideImage from "../Images/guide_hero.svg";
import ReferenceImage from "../Images/reference_hero.svg";
import ManualImage from "../Images/manual_hero.svg";
import ManualPosImage from "../Images/manual_pos_hero.svg";

const useStyles = makeStyles(theme => ({
  landingLinks: {
    marginTop: "24px",
    display: "grid",
    gridTemplateColumns: "repeat(3,1fr)",
    gridGap: "16px",
    "@media(max-width: 667px)": {
      gridTemplateColumns: "1fr"
    }
  },
  link: {
    display: "block",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "4px",
    padding: "16px",
    minHeight: "250px",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.main,
    transition: theme.transitions.create(["background-color"], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.shortest
    }),
    "&:hover": {
      backgroundColor: theme.palette.action.hover
    },
    "& h6": {
      fontSize: "2rem!important",
      fontWeight: `${700}!important`,
      letterSpacing: "0.1rem"
    }
  },
  linkImages: {
    maxWidth: "100%",
    width: "100%",
    height: "200px",
    "@media(max-width: 667px)": {
      height: "auto"
    }
  }
}));

const LandingLinks = props => {
  const classes = useStyles();
  return (
    <div className={classes.landingLinks}>
      <ButtonBase className={classes.link} onClick={() => navigate("/guide/")}>
        <GuideImage className={classes.linkImages} />
        <Typography variant="h6">Guider</Typography>
      </ButtonBase>
      <ButtonBase
        className={classes.link}
        onClick={() => navigate("/reference/")}
      >
        <ReferenceImage className={classes.linkImages} />
        <Typography variant="h6">Referens</Typography>
      </ButtonBase>
      <ButtonBase className={classes.link} onClick={() => navigate("/manual/")}>
        <ManualImage className={classes.linkImages} />
        <Typography variant="h6">Manual</Typography>
      </ButtonBase>
      <ButtonBase
        className={classes.link}
        onClick={() => navigate("/manual-pos/")}
      >
        <ManualPosImage className={classes.linkImages} />
        <Typography variant="h6">Kassamanual</Typography>
      </ButtonBase>
    </div>
  );
};

export default LandingLinks;
